<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AX3UXJ/tc-custom/9781685501273.jpg?1723407365979" alt="This image is the cover for the book Road to Nowhere"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Road to Nowhere
      </h1>
      <p class="bookDescription body article font2">
        <p>Stella is lost in the dark, driving in a storm on an increasingly narrow, unfamiliar country road. What should she do? And why is she running away?<br/><br/>Stella’s car runs off the road and she injures her head. She needs help. Beyond the wild hedgerows and woods is a sprawling mansion with lights in the windows. It seems a party is taking place and Stella’s saved ... or is she?<br/><br/>When Stella meets the host, the stunning Madame Reynard, she’s instantly attracted. In fact, she knows this woman ... intimately. How? Why is she so familiar?<br/><br/>Stella searches for answers in this dark gothic tale of desire and denial.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mags Hayward
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d53c5af